export const ACTIVITIES_ENDPOINTS = {
  home: "/api/Activity/GetHome",
  search: "/api/Activity/Search",
  searchActivity: "/api/Activity/SearchActivity",
  activityFilters: "/api/Activity/GetActivityFilters",
  list: "/api/Activity/GetActivitiesList",
  byId: "/api/Activity/GetById",
  detailsBySlug: "/api/Activity/GetActivityDetailsBySlug",
  categories: "/api/Activity/GetCategories",
  citySpecificExperiences: "/api/Activity/CitySpecificExperiences",
  chooseActivities: "/api/Activity/ChooseActivities",
  featuredActivities: "/api/Activity/GetFeaturedActivities",
  similarActivities: "/api/Activity/GetSimilarActivities",
  homePageHeading: "/api/Activity/GetHomePageHeading",
  homePageAdvertisement: "/api/Activity/GetHomePageAdvertisement",
  listPageHeading: "/api/Activity/GetListPageHeading",
};
